import React, { createContext, useContext, useEffect, useState } from 'react';
import api from '../lib/api';

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [authChecked, setAuthChecked] = useState(false);

  

  //CREAR METODO PARA OBTENER PERMISOS Y DATOS DESPUES DE LOGEAR CON GOOGLE
  
  const checkAuth = async () => {
    
      setLoading(true);

      try {
        const res = await api.post('/auth/user', {});
        const currentPermissions = Array.isArray(res.data?.permissions) ? res.data.permissions : [];
        if (res.data && res.data.success && currentPermissions.length > 0) {
          setAuth({ permissions: currentPermissions });
          localStorage.setItem("User", JSON.stringify(res.data.userData || {}));
          localStorage.setItem("permissions", JSON.stringify(currentPermissions));
          setPermissions(currentPermissions);
        } else {
          setAuth(null);
          setPermissions([]);
          localStorage.removeItem('User');
          localStorage.removeItem('permissions');
        }
      } catch (err) {
        console.error("Error verificando autenticación:", err);
        setError(err.message);
        setAuth(null);
        setPermissions([]);
        localStorage.removeItem('User');
        localStorage.removeItem('permissions');
      } finally {
        setLoading(false);
        setAuthChecked(true);
      }
       
  };
  
  
  const logout = async() => {
    try {
      await api.post('/logout', {});
      
      localStorage.removeItem('User');
      localStorage.removeItem('permissions');
      setPermissions([]);
      setAuth(null);
    } catch (err) {
      console.error("Error al cerrar sesión:", err);
      setError(err.message);
      return false;
    }
    
  };

 useEffect(() => {
   checkAuth();
 }, []);
  
  const [permissions, setPermissions] = useState([]);
  const [auth, setAuth] = useState(() => {
    const permissionsData = localStorage.getItem("permissions");
    if (permissionsData) {
      try {
        return { permissions: JSON.parse(permissionsData) || [] };
      } catch {
        return null;
      }
    }
    return null;
  });
  
  


  return (
    <AuthContext.Provider value={{ auth, setAuth, permissions, setPermissions, logout, loading, error, authChecked }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth debe ser usado dentro de un AuthProvider');
  }

  return context;
}
